import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    myFlows: [],
    myReports: [],
    token: null,
    permissions: [],
    currentCustomer: null,
    groups: [],
    campaigns: [],
    stepTypes: [],
    messagesTemplates: [],
    files: [],
    current_Report:null,
    tokenMetabaseCurrentReport:null,
    sound:true,
    disconnectedInactivity: false,
    disconnectedByNetworkError: false,
    panelChannels: [],
    reasons: [],
    subReasons: [],
    tickets: [],
    ticketDetails: [],
    cancelTicket: [],
    statusLists: [],
    reportSalesGeneralLists: [],
		currentCustomerId: null, 
    indexReport: 0,
    painelAtendimento: null,
    detalheAtendimento: [],
    historicoAtendimento: [],
    agentAttendanceDetails: [],
    inactivityTimeout: 7200000, // 120 minutos em milissegundos
    reportHistoricoDetails: []
  },
  getters: {
    getListReports(state) {
      return state.myReports
    },
    getListFlows(state) {
      return state.myFlows
    },
    getListDataInformation(state) {
      return state.permissions.customer
    },
    getListUserFunctions(state) {
      return state.permissions.user_Function
    },
    getListGroups(state) {
      return state.groups
    },
    getListCampaigns(state) {
      return state.campaigns
    },
    getListStepType(state) {
      return state.stepTypes
    },
    getCurrentCustomer(state) {
      return state.currentCustomer
    },
    getUserInformation(state) {
      return state.permissions
    },
    getMessagesTemplates(state) {
      return state.messagesTemplates
    },
    getCurrentFiles(state) {
      return state.files
    },
    getCurrentReport(state) {
      return state.current_Report
    },
    getTokenMetabaseCurrentReport(state) {
      return state.tokenMetabaseCurrentReport
    },
    getChannelsForPanel(state) {
      return state.panelChannels
    },
    getCurrentReasons(state){
      return state.reasons
    },
    getCurrentSubReasons(state) {
      return state.subReasons
    },
    getTickets(state){
      return state.tickets
    },
    getTicketDetails(state){
      return state.ticketDetails
    },
    getCancelTicket(state){
      return state.cancelTicket
    },
    getStatusLists(state){
      return state.statusLists
    },
    getReportSalesGeneralList(state){
      return state.reportSalesGeneralLists
    },
    getIndexReport(state){
      return state.indexReport
    },
    getPainelAtendimento(state){
      return state.painelAtendimento
    },
    getDetalheAtendimento(state){
      return state.detalheAtendimento
    },
    getHistoricoAtendimento(state){
      return state.historicoAtendimento
    },
    getAgentAttendanceDetails(state){ 
      return state.agentAttendanceDetails
    },
    getHistoricoReportDetails(state){
      return state.reportHistoricoDetails
    }
  },
  mutations: {
    setIndexReport(state, index){
      state.indexReport = index
    },
    setCurrentCustomerId(state, customerId) {
			state.currentCustomerId = customerId;
		},
    setDisconnectedInactivity(state,data){
      state.disconnectedInactivity = data;
    },
    setDisconnectedByNetworkError(state,data) {
      state.disconnectedByNetworkError = data;
    },
    setListReports(state,data){
      state.myReports = data;
    },
    setListFlows(state, data) {
      state.myFlows = data;
    },
    setPermisions(state, data) {
      state.permissions = data;
    },
    setCurrentCostumer(state, data) {
      state.currentCustomer = data;
    },
    setGroups(state, data) {
      state.groups = data;
    },
    setCampaigns(state, data) {
      state.campaigns = data;
    },
    setStepTypes(state, data) {
      state.stepTypes = data;
    },
    setMessagesTemplates(state, data) {
      state.messagesTemplates = data
    },
    setLoadFiles(state, data) {
      state.files = data;
    },
    setCurrent_Report(state,report){
      state.current_Report = report
    },
    setTokenMetabaseCurrent_Report(state,token){
      state.tokenMetabaseCurrentReport = token
    },
    setSoundBell(state,sound){
      state.sound = sound
    },
    setInitialData(state) {
      state.permissions = [];
      state.currentCustomer = null;
      state.groups = [];
      state.campaigns = [];
      state.stepTypes = [];
      state.messagesTemplates = [];
      state.files = [];
      state.current_Report = null;
      state.tokenMetabaseCurrentReport = null;
      state.sound = true;
    },
    setChannelsForPanel(state, data) {
      state.panelChannels = data
    },
    setReasons(state, data) {
      state.reasons = data;
    },
    setSubReason(state, data) {
      state.subReasons = data;
    },
    setTickets(state, data){
      state.tickets = data
    },
    setTicketDetails(state, data){
      state.ticketDetails = data
    },
    setCancelTicket(state, data){
      state.cancelTicket = data
    },
    setStatusList(state, data){      
      state.statusLists = data
    },
    setReportSalesGeneralList(state, data){      
      state.reportSalesGeneralLists = data
    },
    setPainelAtendimento(state, data){
      state.painelAtendimento = data
    },
    setDetalheAtendimento(state, data){
      state.detalheAtendimento = data
    },
    setHistoricoAtendimento(state, data){
      state.historicoAtendimento = data
    },
    setAgentAttendanceDetails(state, data){ 
      state.agentAttendanceDetails = data
    },
    setHistoricoReportDetails(state, data){
      state.reportHistoricoDetails = data
    }
  },
  actions: {
    async listarFluxo({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`List_Flow?Active_Flow=true&Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          let fluxos = r.data.reverse();
          commit('setListFlows',fluxos);
        })
        .catch(() => {
          this.logout();
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async getPermissions({commit}, idUser){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      return await axios
        .get(
          `User_Data_Perm?user_id=${idUser}`,
          {
            headers: {
              accept: "*/*",
              Authorization: `bearer ${token}`,
            }
          }
        )
        .then((r) => {
          console.log(r.data)
          commit('setPermisions', r.data);
          commit('setListReports', r.data.report)
          commit('setChannelsForPanel', r.data.channel)
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {

        });
    },
    async listGroup({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`User_Att_Group_List?Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setGroups', r.data);
        })
        .catch(() => {
          //this.error = true
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async campaignList({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`Campaign_List?Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setCampaigns', r.data);
        })
        .catch(() => {
          //console.log("error obteniendo la lista de las campañas",e)
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async listStepType({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`List_Step_Type?Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setStepTypes', r.data);
        })
        .catch(() => {
          //this.error = true
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async listMessagesTemplates({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`Message_Template_List?Customer_Id=${idClient}`, {
        headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
        },
        })
        .then((r) => {
            commit('setMessagesTemplates', r.data)
        })
        .catch(() => {
        //this.error = true
        })
        .finally(() => {
        //this.loading = false
        });
    },
    async listLoadFiles({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`Att_File_List?Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setLoadFiles', r.data);
        })
        .catch(() => {
          //this.error = true
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async GetTokenMetabase({commit}, data) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`Token_Metabase?customer_Id=${data.customer_id}&visualization_type=${data.visualization_type}&visualization_id=${data.visualization_id}&key=${data.key}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setTokenMetabaseCurrent_Report', r.data);
        })
        .catch(() => {
          //this.error = true
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async ListReason({commit}, idClient) {
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      console.log("data". data)
      await axios
        .get(`Reason_Att?Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setReasons', r.data);
        })
        .catch(() => {
          // if(error.response.status == 401) {
          //   this.$store.commit('setDisconnectedByNetworkError', true)
          //   this.logout()
          // }
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async ListSubreason({commit}, idClient){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
        .get(`SubReason_Att?Customer_Id=${idClient}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${token}`,
          },
        })
        .then((r) => {
          commit('setSubReason', r.data);
        })
        .catch(() => {
          // if(error.response.status == 401) {
          //   this.$store.commit('setDisconnectedByNetworkError', true)
          //   this.logout()
          // }
        })
        .finally(() => {
          //this.loading = false
        });
    },
    async ListTickets({commit}, filter){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      let url = `Trip_List?`;

      for (let key in filter) {
        if (filter[key]) {
          if (key === 'Order_Status') {
            url += `&${key}=${filter[key].value}`; 
          } else {
            url += `&${key}=${filter[key]}`;
          }
        }
      }
      
      await axios
      .get(url, {
        
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setTickets', r.data);
      })
      .catch(() => {
        
      })
      .finally(() => {
        //this.loading = false
      });
    },
    async getTripDetails({commit}, data){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Trip_Details?Customer_Id=${data.Customer_Id}&Order_Id=${data.Id}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setTicketDetails', r.data);
      })
      .catch(() => {
             
      })
      .finally(() => {
        //this.loading = false
      });
    },
    async cancelTripTicket({commit}, orderId){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Trip_Cancel?OrderId=${orderId}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setCancelTicket', r.data);
      })
      .catch(() => {
             
      })
      .finally(() => {
        //this.loading = false
      });
    },
    async getTripStatusList({commit}, idClient){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Status_List?Customer_Id=${idClient}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setStatusList', r.data);
       
      })
      .catch((error) => {
         console.log('erro no statuslist: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    },    
    async getGeneralSalesList({commit}, data){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Report_Sales_General?Customer_Id=${data.customerId}&Status_Id=${data.statusId}&Start_Date=${data.startDate}&End_Date=${data.endDate}&Name_Procedure=${data.storedProcedureName}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setReportSalesGeneralList', r.data);
       
      })
      .catch((error) => {
         console.log('erro no statuslist: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    },
    async getPainelAtendimento({commit}, data){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      console.log("token store: " + token )
      await axios
      .get(`Panel_Attendance_Detail?Customer_Id=${data.customerId}&Start_Date=${data.startDate}&End_Date=${data.endDate}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setPainelAtendimento', r.data);
       
      })
      .catch((error) => {
         console.log('erro no painelAtendimento: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    },
    async getDetalheAtendimento({commit}, data){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Report_Sales_General?Customer_Id=${data.customerId}&Status_Id=${data.statusId}&Start_Date=${data.startDate}&End_Date=${data.endDate}&Name_Procedure=${data.storedProcedureName}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setDetalheAtendimento', r.data);
       
      })
      .catch((error) => {
         console.log('erro no DetalheAtendimento: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    },
    async getHistoricoAtendimento({commit}, data){
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Report_Sales_General?Customer_Id=${data.customerId}&Status_Id=${data.statusId}&Start_Date=${data.startDate}&End_Date=${data.endDate}&Name_Procedure=${data.storedProcedureName}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setHistoricoAtendimento', r.data);
       
      })
      .catch((error) => {
         console.log('erro no HistoricoAtendimento: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    },
     async getAgentAttendanceDetails({commit}, data){
     
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Agent_Attendance_Detail?Customer_Id=${data.customerId}&Start_Date=${data.startDate}&End_Date=${data.endDate}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setAgentAttendanceDetails', r.data);
       
      })
      .catch((error) => {
         console.log('erro no AgentAttendanceDetails: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    },
     async getReportHistoricoDetails({commit}, data){
     
      let token = JSON.parse(localStorage.getItem("authUser")).token;
      await axios
      .get(`Report_Historic_Att_Details?Customer_Id=${data.customerId}&Start_Date=${data.start_Date}&End_Date=${data.end_Date}&Phone=${data.phone_Number}`, {
        headers: {
          accept: "*/*",
          Authorization: `bearer ${token}`,
        },
      })
      .then((r) => {
        commit('setHistoricoReportDetails', r.data);
       
      })
      .catch((error) => {
         console.log('erro no getReportHistoricoDetails: ' + error)    
      })
      .finally(() => {
        //this.loading = false
      });
    }
  },
  modules: {
  }
})
